import MainConnection from "./MainConnection";

export default {
  requestSendOtp: async function(phoneNumber, type) {
    try {
      const requestParam = {
        number: phoneNumber,
        flag: type
      };
      const response = await MainConnection.request().post(
        "/number/requestOtp",
        requestParam
      );
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  requestVerifyOtp: async function(params) {
    try {
      const requestParam = {
        transaction_id: params.trx,
        otp_code: params.otp
      };
      const response = await MainConnection.request().post(
        "/number/verifyOtp",
        requestParam
      );
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  requestGetImeiNumber: async function(dahNumber) {
    try {
      const response = await MainConnection.request().get(
        "/number/imei?msisdn=" + dahNumber
      );
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  }
};
